export default {
  data: function () {
    return {
      dataSourcesData: {
        LoRaWAN: {
          image: 'lorawan-logo.svg',
        },
        Sigfox: {
          image: 'sigfox-logo.png',
        },
        'NB-IoT': {
          image: 'nbiot-logo.png',
        },
        Discovergy: {
          image: 'discovergy-logo.png',
        },
        Temetra: {
          image: 'temetra-logo.png',
        },
        Actility: {
          image: 'actility-logo.png',
        },
        Filesystem: {
          name: 'File System',
          image: 'filesystem-logo.svg',
        },
        Webhook: {
          image: 'webhook-logo.png',
        },
        auto_id: {
          name: 'Auto-ID Webhook',
          image: 'webhook-logo.png',
        },
      },
    };
  },
};
